<template>
    <div class="rating-component">
        <star-rating :rating="rating" :read-only="true" :increment="0.01" :star-size="20" :rtl="isRTL" :show-rating="false"></star-rating>
    </div>
  </template>
  
  <script>
import StarRating from 'vue-star-rating'  
import { mapGetters } from 'vuex';
  export default {
    components: {
      StarRating
    },
    props:{
        rating:{
            type:Number,
        }
    },
    data() {
      return {
        isRTL :true,
       
      }
    },
    computed:{
        ...mapGetters(['currentLanguage']),
    },
    methods: {
      updateRating(newRating) {
        this.rating = newRating
      }
    },
    watch: {
        currentLanguage: {
            handler(newLang, oldLang) {
                this.isRTL = newLang === 'ar';            
            },
            immediate: true, // Run the handler immediately when the component is mounted
        }
    }
  }
  </script>
  
  <style>
  /* Optional styling */
  .vue-star-rating-star{
    overflow: hidden !important;
  }
  .rating-container {
  overflow: hidden !important;
  max-width: 400px !important;
  direction: rtl; /* Explicitly set direction */
  display: flex;
}
  </style>
  